<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <input
      type="number"
      :id="id"
      class="w-full"
      :value="modelValueComputed"
      :disabled="disabled"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :class="{
        'p-invalid': validation?.$error,
      }"
      :aria-describedby="`${id}-help`"
      @input="$emit('update:modelValue', $event.target.valueAsNumber || 0)"
    />
    <span
      v-if="
        validation?.$error &&
        validation.required &&
        validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error && validation.integer && validation.integer.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.integer.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.minValue &&
        validation.minValue.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.minValue.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.maxValue &&
        validation.maxValue.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.maxValue.$message.replace("Value", PropName) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    labelClass: {
      type: String,
      default: "form-label",
    },
    PropName: {
      type: String,
      default: "",
    },
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  computed: {
    modelValueComputed: {
      get() {
        return this.modelValue === null ? 0 : this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
input{
    color: #777 !important;
    font-size: 16px;
    width: 100%;
    resize: none;
    box-shadow: none;
    border-radius: 0.25rem;
    font-weight: 500;
    line-height: 1;
    font-family: "voyado Text";
    padding: 10px;
}

</style>